export default __webpack_public_path__ + "static/media/susza.159cb106.svg";